<template>
    <div class="pagination prevent-close">
        <div class="pagination__wrapper">
            <button @click="$emit('prev')" class="pagination__item pagination__item_action">
                <ArrowLeft :size="18"></ArrowLeft>
            </button>

            <button
                class="pagination__item pagination__item_control"
                :class="{ pagination__item_active: page == first }"
                @click="$emit('set', first)"
            >
                {{ first }}
            </button>

            <div class="pagination__divider" v-show="isFirstDots">...</div>

            <div class="pagination__inner">
                <slot></slot>
            </div>

            <div class="pagination__divider" v-show="isLastDots">...</div>

            <button
                class="pagination__item pagination__item_control"
                :class="{ pagination__item_active: page == pages }"
                @click="$emit('set', pages)"
            >
                {{ pages }}
            </button>

            <button @click="$emit('next')" class="pagination__item pagination__item_action">
                <ArrowRight :size="18"></ArrowRight>
            </button>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import ArrowLeft from 'vue-material-design-icons/ChevronLeft';
import ArrowRight from 'vue-material-design-icons/ChevronRight';

import last from 'lodash/last';
import first from 'lodash/first';

@Component({
    components: {
        ArrowLeft,
        ArrowRight,
    },
})
class PagePaginateControl extends Vue {
    @Prop(Array) views;
    @Prop(Number) page;
    @Prop(Number) pages;

    first = 1;

    get isFirstDots() {
        return first(this.views) !== this.first + 1 && this.pages > 5;
    }

    get isLastDots() {
        return last(this.views) !== this.pages - 1 && this.pages > 5;
    }
}

export default PagePaginateControl;
</script>
<style lang="scss">
.pagination {
    display: flex;
    width: 100%;
    height: auto;
    justify-content: flex-end;

    &__wrapper {
        display: flex;
        align-items: center;
        position: relative;
        padding: 5px 15px;
        gap: 6px;
    }

    &__inner {
        display: flex;
        gap: 6px;
    }

    &__item {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 30px;
        height: 30px;
        min-width: 30px;
        margin: 0 !important;
        padding: 0 !important;
        border: 1px solid #e3e5e8;
        border-radius: 9px;
        background: #fff;
        color: #5f6368;
        font: 500 0.8125rem var(--font-family);
        cursor: pointer;
        transition: background 0.2s, border-color 0.2s, color 0.2s;

        &:hover {
            background: #f6f7f8;
            border-color: #d4d7db;
        }

        &_active {
            background: #00a55a;
            border-color: #00a55a;
            color: var(--text-white);

            &:hover {
                background: #00a55a;
                border-color: #00a55a;
            }
        }
    }

    &__divider {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        height: 30px;
        min-width: 20px;
        color: #5f6368;
    }
}
</style>
